import React from "react";
import htmlLogo from "../assets/htmllogo.png";
import cssLogo from "../assets/csslogo.png";
import jsLogo from "../assets/jslogo.png";
import tsLogo from "../assets/tslogo.png";
import reactLogo from "../assets/reactjslogo.png";
import bootstrapLogo from "../assets/bootstraplogo.png";
import muiLogo from "../assets/muilogo.png";
import nextLogo from "../assets/nextjslogo.png";
import nodejsLogo from "../assets/nodejslogo.png";
import prismaLogo from "../assets/prismalogo.png";
import postsqlLogo from "../assets/postgresqlllogo.png";
import gitLogo from "../assets/gitlogo.png";

import { Element } from "react-scroll";

const Tools = () => {
  return (
    <Element name="tools-section" className="tools">
      <div>
        <div id="tools-section" className="tools-parent-div ">
          <h1>Tech I use for coding .</h1>
        </div>
        <div className="tools-div">
          <img src={htmlLogo} alt="html-logo" className="tech-logo" />
          <img src={cssLogo} alt="css-logo" className="tech-logo" />
          <img src={jsLogo} alt="js-logo" className="tech-logo" />
          <img src={tsLogo} alt="ts-logo" className="tech-logo" />
          <img src={reactLogo} alt="react-logo" className="tech-logo" />
          <img src={bootstrapLogo} alt="bootstrap-logo" className="tech-logo" />
          <img src={muiLogo} alt="mui-logo" className="tech-logo" />
          <img src={nextLogo} alt="next-logo" className="tech-logo" />
          <img src={nodejsLogo} alt="nodejs-logo" className="tech-logo" />
          <img src={prismaLogo} alt="prisma-logo" className="tech-logo" />
          <img src={postsqlLogo} alt="postsql-logo" className="tech-logo" />
          <img src={gitLogo} alt="git-logo" className="tech-logo" />
        </div>
      </div>
    </Element>
  );
};

export default Tools;
